import React, { useEffect, useState } from 'react'
import { Box, IconButton, Link, Typography } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInput from 'components/custom/AdxInput'
import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import Astronaut from '../assets/astronaut.svg'
import { loginPassword } from 'services/api/signup'
import { useMutation } from 'react-query'
import AdxButton from 'components/custom/AdxButton'

const SignUpPassword = () => {
  const navigate = useNavigate()
  const location = useLocation()
  // declaring states
  const [password, setPassword] = useState('')
  const [isError, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  // helpers functions
  const handleBack = () => {
    navigate('/signup')
  }

  // form field states and function
  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const PasswordEye = () => {
    return (
      <IconButton onClick={() => handleShowPassword()} sx={{ padding: 0 }}>
        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
      </IconButton>
    )
  }

  const handleChange = (e) => {
    setPassword(e.target.value)
    setError(false)
    setErrorMessage('')
  }

  // react query mutate hook
  const { isLoading: loginPasswordLoading, mutate: loginPasswordQuery } = useMutation(
    (password) => loginPassword(password),
    {
      onSuccess: async ({ data }) => {
        navigate(`/signup/${data?.email}`, {
          state: {
            data,
            backgroundLocation: location,
          },
        })
      },
      onError: async (err) => {
        setError(true)
        setErrorMessage('Wrong password')
      },
    }
  )

  const handleSubmit = (e) => {
    e.preventDefault()
    // submit function
    loginPasswordQuery({ email: location.state.email, password })
  }

  // redirect if the user not from signup page
  useEffect(() => {
    if (!location?.state?.fromCheckEmail) {
      navigate('/signup')
    }
  }, [])

  return (
    <OnboardingContainer
      bgColorRight="alternate.main"
      topRightPhoto="10%"
      leftRightPhoto="75%"
      heightRightPhoto="100%"
      transformRightPhoto={`translate(${-50}%, ${0}%)`}
    >
      <Box
        component="img"
        src={Astronaut}
        position="fixed"
        bottom={0}
        right={0}
        width="calc(100vw * 0.55)"
        display={{ xs: 'none', lg: 'block' }}
      />
      <Box
        height={'100%'}
        width={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'flex-end' }}
        alignItems={{ xs: 'center', lg: 'center' }}
      >
        <form
          onSubmit={handleSubmit}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Box
            width={{ xs: '100%', lg: '500px' }}
            height={{ xs: '90vh', lg: '500px' }}
            mr={{ lg: 7.6875 }}
            p={{ xs: 2, lg: 0 }}
            position={'relative'}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            margin="0 auto"
          >
            <Box>
              <Box mb={4}>
                <Typography variant="h1" mb={1}>
                  Enter your password
                </Typography>
              </Box>
              <AdxInput
                label="Password"
                type={showPassword ? 'text' : 'password'}
                onChange={handleChange}
                isErrorShown={isError}
                errorMessage={<AdxErrorMessage>{errorMessage}</AdxErrorMessage>}
                endAdornment={<PasswordEye />}
              />

              <Link
                style={{ textDecoration: 'none' }}
                // AFI: QUICKFIX FOR FORGOT PASSWORD (REDIRECT TO NEW FORGOT PASSWORD PAGE IN CONSOLIDATED WEBPAGE IN FUTURE)
                href={process.env.REACT_APP_ADNEXIO_JOBS_URL + '/forgot-password'}
                target={'_blank'}
                rel="noreferrer"
              >
                <Typography mt={2} variant="body1" color="alternate.main">
                  Forgot Password ?
                </Typography>
              </Link>
            </Box>
            <Box>
              <Box mt={10} mb={2} display="flex" gap={1}>
                <AdxButton
                  variant={'outlined'}
                  onClick={handleBack}
                  sx={{ minWidth: '20px', pl: 3, borderWidth: 2 }}
                >
                  <ArrowBackIosIcon />
                </AdxButton>
                <AdxButton
                  type="submit"
                  fullWidth
                  isLoading={loginPasswordLoading}
                  disabled={loginPasswordLoading}
                >
                  Continue
                </AdxButton>
              </Box>
              <Typography variant="body1" textAlign="center">
                Organization already existed? Sign in as employee{' '}
                <Link
                  component={RouterLink}
                  to={process.env.REACT_APP_ADNEXIO_NEXT_URL + '/signin'}
                  style={{ textDecoration: 'none' }}
                  sx={{ color: 'alternate.main' }}
                >
                  here
                </Link>
              </Typography>
            </Box>
          </Box>
        </form>
      </Box>
    </OnboardingContainer>
  )
}

export default SignUpPassword
